import { render, staticRenderFns } from "./TopicLabel.vue?vue&type=template&id=4419fee7&"
import script from "./TopicLabel.vue?vue&type=script&lang=js&"
export * from "./TopicLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports